import { Controller } from "@hotwired/stimulus"

// Mostra (e torna obrigatório) o campo de estabelecimento apenas para os tipos
// de lançamento que acontecem em um estabelecimento — hoje só COMPRA. Os demais
// débitos são cobranças da instituição (mensalidade, anuidade, taxa...) e não
// têm estabelecimento. Lê o data-exige-estabelecimento da option selecionada.
// Avalia ao conectar e a cada troca do tipo.
export default class extends Controller {
  static targets = ["tipo", "field", "select"]

  connect() {
    this.toggle()
  }

  toggle() {
    const option = this.tipoTarget.options[this.tipoTarget.selectedIndex]
    const exige = option?.dataset.exigeEstabelecimento === "true"

    this.fieldTarget.style.display = exige ? "block" : "none"
    this.selectTarget.toggleAttribute("required", exige)
    // Evita enviar um estabelecimento escolhido antes da troca de tipo
    if (!exige) this.selectTarget.value = ""
  }
}
